<section class="mat-typography">
    <h1> Your Subscriptions </h1>

  <div *ngIf="quota_usage | async as q_usage; else usageLoading">
    <div *ngIf="!loadedProducts; else productsTable">
        <app-runbox-loading text="Loading your subscriptions...">
        </app-runbox-loading>
    </div>

    <ng-template #productsTable>
      <ng-container *ngIf="active_products.length > 0; else buyPlans">

        <p>
            These are the subscriptions associated with your account. You may renew any of them at any time, which will add the new period to the end of your current subscription.
        </p>
        <p>
            To upgrade to another account plan, please see <a routerLink="/account/plans">Plans & Upgrades</a>.
        </p>

        <table mat-table [dataSource]="active_products" [ngStyle]="{ width: '100%' }" multiTemplateDataRows class="renewalsTable">
            <ng-container matColumnDef="renewal_name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let p">
                  <span style="font-weight: bold;"> {{ p.name }} </span>
                    <span *ngIf="p.pid === current_subscription"> – your current subscription </span>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                  <span *ngIf="!showExpired">
                    <button mat-raised-button (click)="showHideExpiredProducts()">
                      Show All Expired Products
                    </button>
                  </span>
                  <span *ngIf="showExpired">
                    <button mat-raised-button (click)="showHideExpiredProducts()">
                      Hide Old Expired Products
                    </button>
                  </span>
                </td>
            </ng-container>
            <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef> Quantity </th>
                <td mat-cell *matCellDef="let p">
                    {{ p.quantity }}
                    <span *ngIf="p.subtype === 'subaccount'">
                        ({{ p.subaccounts.length }} in use)
                        <button mat-icon-button *ngIf="p.subaccounts.length > 0" (click)="showSubsDialog(p)">
                            <mat-icon svgIcon="information-outline"
                                [matTooltip]="'Associated accounts: ' + p.subaccounts.join(', ')"></mat-icon>
                        </button>
                    </span>
                </td>
            </ng-container>
            <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef> Price </th>
                <td mat-cell *matCellDef="let p">
                    {{ p.currency }} {{ p.price }}
                </td>
            </ng-container>
            <ng-container matColumnDef="active_from">
                <th mat-header-cell *matHeaderCellDef> Active From </th>
                <td mat-cell *matCellDef="let p">
                    {{ p.active_from.format('YYYY-MM-DD') }}
                </td>
            </ng-container>
            <ng-container matColumnDef="active_until">
                <th mat-header-cell *matHeaderCellDef> Active Until </th>
                <td mat-cell *matCellDef="let p">
                    {{ p.active_until.format('YYYY-MM-DD') }}
                </td>
            </ng-container>
            <ng-container matColumnDef="hints">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let p">
                    <strong *ngIf="p.expired">
                        (expired {{ p.active_until.fromNow() }})
                    </strong>
                    <mat-error *ngIf="p.expires_soon" style="font-weight: bold;">
                        (expires {{ p.active_until.fromNow() }})
                    </mat-error>
                </td>
            </ng-container>
            <ng-container matColumnDef="recur">
                <th mat-header-cell *matHeaderCellDef> Auto Renew </th>
                <td mat-cell *matCellDef="let p">
                    <app-account-renewals-autorenew-toggle-component [p]="p" (toggle)="toggleAutorenew(p)"
                        *ngIf="!(p.type === 'addon' && p.name.toLowerCase().includes('storage'))">
                    </app-account-renewals-autorenew-toggle-component>
                </td>
            </ng-container>
            <ng-container matColumnDef="renew">
                <th mat-header-cell *matHeaderCellDef> Renew Now </th>
                <td mat-cell *matCellDef="let p">
                    <app-account-renewals-renew-now-button-component [p]="p" [usage]="q_usage" (clicked)="renew(p)"
                        *ngIf="!(p.type === 'addon' && p.name.toLowerCase().includes('storage'))">
                    </app-account-renewals-renew-now-button-component>
                </td>
            </ng-container>
            <ng-container matColumnDef="expandedDetails">
                <td mat-cell *matCellDef="let p" [attr.colspan]="displayedColumns.length">
                    <div class="expandedDetails">
                        <!-- yo dawg, I heard you like tables -->
                        <table class="detailsTable">
                            <tr>
                                <td> Quantity </td>
                                <td> {{ p.quantity }} </td>
                            </tr>
                            <tr *ngIf="p.subtype === 'subaccount'">
                                <td> In use </td>
                                <td style="display: flex; align-items: baseline;">
                                    {{ p.subaccounts.length }}
                                    <button mat-icon-button *ngIf="p.subaccounts.length > 0"
                                        (click)="showSubsDialog(p)">
                                        <mat-icon svgIcon="information-outline"></mat-icon>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td> Active From </td>
                                <td> {{ p.active_from.format('YYYY-MM-DD') }} </td>
                            </tr>
                            <tr>
                                <td> Active Until </td>
                                <td> {{ p.active_until.format('YYYY-MM-DD') }} </td>
                            </tr>
                            <tr>
                                <td> </td>
                                <td>
                                    <span *ngIf="p.expired">
                                        (expired {{ p.active_until.fromNow() }})
                                    </span>
                                    <mat-error *ngIf="p.expires_soon" style="font-weight: bold;">
                                        (expires {{ p.active_until.fromNow() }})
                                    </mat-error>
                                </td>
                            </tr>
                            <tr>
                                <td> Auto Renew </td>
                                <td>
                                    <app-account-renewals-autorenew-toggle-component [p]="p"
                                        (toggle)="toggleAutorenew(p)">
                                    </app-account-renewals-autorenew-toggle-component>
                                </td>
                            </tr>
                            <tr>
                                <td> Renew Now </td>
                                <td>
                                    <app-account-renewals-renew-now-button-component [p]="p" (clicked)="renew(p)">
                                    </app-account-renewals-renew-now-button-component>
                                </td>
                            </tr>
                        </table>
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"
                [ngStyle]="{ 'display': mobileQuery.matches ? 'none' : null }">
            <tr mat-row *matRowDef="let row; columns: displayedColumns" class="regularRow">
            </tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetails']" class="detailsRow"></tr>
            <tr mat-footer-row *matFooterRowDef="['renewal_name']"></tr>
        </table>

      </ng-container>
    </ng-template>
  </div>

  <ng-template #buyPlans>
    <p>You do not have any of our currently available products.</p>
    <p>Please visit <a routerLink='/account/plans'>Plans & Upgrades</a> to subscribe.</p>
  </ng-template>

  <ng-template #usageLoading>
    <app-runbox-loading text="Loading your usage to tailor page...">
    </app-runbox-loading>
  </ng-template>
</section>
